import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.name == "project" || from.name == "project") {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.home.length === 0) {
          store.dispatch("loadHome");
          store.dispatch("loadArtists");
          store.dispatch("loadAbout");
        } else {
          next();
        }
        next();
      }
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.about.length === 0) {
          store.dispatch("loadAbout").then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/artists",
      name: "artists",
      component: () =>
        import(/* webpackChunkName: "Artists" */ "./views/Artists.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.artistlist.length === 0) {
          store.dispatch("loadArtists").then(next);
        } else {
          next();
        }
      }
    },
    {
      path: "/artists/:uid",
      name: "artist",
      component: () =>
        import(/* webpackChunkName: "Artist" */ "./views/Index.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        // console.log(from);
        let existing = store.state.artists.find(
          art => art.uid == to.params.uid
        );
        if (!existing) {
          store.dispatch("loadArtist", {
            uid: to.params.uid
          });
          next();
        } else {
          next();
        }
      },
      children: [
        {
          path: "/artists/:uid/:project",
          name: "project",
          component: () =>
            import(/* webpackChunkName: "Project" */ "./views/Project.vue"),
          props: true,
          beforeEnter: (to, from, next) => {
            // console.log(from);
            store.state.project = [];
            next();
          }
        }
      ]
    },
    {
      path: "/newsletter",
      name: "newsletter",
      component: () =>
        import(/* webpackChunkName: "Newsletter" */ "./views/Newsletter.vue")
    },
    {
      path: "/production",
      name: "production",
      component: () =>
        import(/* webpackChunkName: "Productione" */ "./views/Production.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.production.length === 0) {
          store.dispatch("loadProduction");
        } else {
          next();
        }
        next();
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
